module.exports = "/_next/static/images/3fd99bcdcb54c671f7dafce749963414-mulher-com-cachos-maravilhosos-segurando-cartao-md@2x.jpg";